import { lazy, Suspense, useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import { Navigation, Pagination } from "swiper";

import SubText from "components/shared/SubText";
import { RouteName } from "constant/routeNames";
import { Link } from "react-router-dom";
import VideoService from "services/video/VideoService";
import "swiper/css";
import "swiper/css/pagination";
import TrendMovieSkeletion from "../../components/skeleton/TrendMovieSkeletion";
import ErrorBoundary from "antd/es/alert/ErrorBoundary";
import SectionHeading from "components/shared/SectionHeading";

const MovieCarouselCard = lazy(
  () => import("pages/videoPage/shared/MovieCarouselCard"),
);

function TrendMovies({ favorite }: any) {
  const [videos, setVideos] = useState<any>([]);

  const [isLoading, setIsLoading] = useState<any>(false);

  useEffect(() => {
    setIsLoading(true);
    VideoService.getRandomMovies()
      .then((res: any) => {
        setIsLoading(false);
        setVideos(res.data);
      })
      .catch((e) => {
        setIsLoading(false);
        // console.log(e);
      });
  }, []);

  return (
    <div>
      {!isLoading && (
        <div className="flex justify-between items-center w-[95%]">
          <SectionHeading text="Discover Movies" className="font-bold" />
          <Link to={RouteName.SeeAllMoviesRoute}>
             <p className="flex items-center gap-1 text-sm font-bold text-[#F50537] transition-all duration-200 group-hover:gap-2">
              See all
              <span className="transition-transform duration-200 group-hover:translate-x-0.5">
                →
              </span>
            </p>
          </Link>
        </div>
      )}

      {!isLoading && (
        <ErrorBoundary>
          <Suspense fallback={<TrendMovieSkeletion />}>
            <Swiper
              slidesPerView={6}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                370: {
                  slidesPerView: 2,
                },
                700: {
                  slidesPerView: 3,
                },
                1000: {
                  slidesPerView: 4,
                },
                1200: {
                  slidesPerView: 5,
                },
                1400: {
                  slidesPerView: 6,
                },
                1600: {
                  slidesPerView: 7,
                },
              }}
              modules={[Pagination, Navigation]}
              navigation={true}
              className="mt-10 mb-10 mySwiper"
            >
              {videos?.map((card: any, i: number) => (
                <SwiperSlide key={i}>
                  <div className="mx-3 max-sm:mx-1">
                    <MovieCarouselCard
                      id={card?.id}
                      time={card?.runtime}
                      title={card?.title}
                      info={card?.title}
                      year={card?.released_at}
                      type={card?.genre}
                      img={card?.thumbnail}
                      thumbnail_url={card?.thumbnail_url}
                      slug={card?.slug}
                      favoriteMovies={favorite}
                      movie={card}
                      plan_id={card?.plan_id}
                    />
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </Suspense>
        </ErrorBoundary>
      )}
      {isLoading && <TrendMovieSkeletion />}
    </div>
  );
}

export default TrendMovies;
